module.exports = __webpack_public_path__ + "static/img/thumb_25.94c77ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu/thumb_25.png
// module id = cp0O
// module chunks = 0